import * as yup from 'yup';
import { DateSchema } from 'yup';
import { UserErrorMessages, UserValidation } from '../../../../types';
import { minMaxDate } from '../minMaxDate';

export interface DateValidation extends Pick<UserValidation, 'required' | 'min' | 'max'> {}

// build validation for dates
export const buildDateValidators = (
  { required, min, max }: DateValidation,
  errorMessages?: UserErrorMessages,
  parentValidationDefinition: { [key: string]: any } = {}
) => {
  let schema: DateSchema<Date | undefined | null, object> = yup
    .date()
    .typeError(required?.[0] ?? 'Invalid date format')
    .default(undefined);

  if (required) schema = schema.required(...required).nullable() as any;
  if (max) {
    const dateModelPath = Object.keys(parentValidationDefinition ?? {}).find((k) => k === max[0]);
    if (dateModelPath) {
      schema = schema.when(dateModelPath, (selectedDateValue: string | undefined, schema: DateSchema) => {
        if (!selectedDateValue) return schema;
        return schema.max(...minMaxDate([selectedDateValue, max[1]!, max[2]!], false));
      });
    } else {
      schema = schema.max(...minMaxDate(max, false)).nullable();
    }
  }

  if (min) {
    const dateModelPath = Object.keys(parentValidationDefinition ?? {}).find((k) => k === min[0]);
    if (dateModelPath) {
      schema = schema.when(dateModelPath, (selectedDateValue: string | undefined, schema: DateSchema) => {
        if (!selectedDateValue) return schema;
        return schema.min(...minMaxDate([selectedDateValue, min[1]!, min[2]!], true));
      });
    } else {
      schema = schema.min(...minMaxDate(min, true)).nullable();
    }
  }

  return schema;
};
